var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.832 21.8012C15.958 21.1752 20 18.9262 20 13.1112C20 7.82017 16.127 4.29617 13.342 2.67717C12.723 2.31717 12 2.79018 12 3.50517V5.33318C12 6.77518 11.394 9.40718 9.71 10.5022C8.85 11.0612 7.92 10.2242 7.816 9.20418L7.73 8.36618C7.63 7.39218 6.638 6.80118 5.86 7.39517C4.461 8.46018 3 10.3302 3 13.1102C3 20.2212 8.289 22.0002 10.933 22.0002C11.0877 22.0002 11.249 21.9952 11.417 21.9852C11.863 21.9292 11.417 22.0842 12.832 21.8002",
    fill: "#2D045D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.4444C8 21.0644 10.111 21.8744 11.417 21.9864C11.863 21.9304 11.417 22.0854 12.832 21.8014C13.871 21.4344 15 20.4924 15 18.4444C15 17.1474 14.181 16.3464 13.54 15.9714C13.344 15.8564 13.116 16.0014 13.099 16.2274C13.043 16.9454 12.353 17.5174 11.884 16.9714C11.469 16.4894 11.294 15.7844 11.294 15.3334V14.7434C11.294 14.3894 10.937 14.1534 10.631 14.3354C9.495 15.0084 8 16.3944 8 18.4444Z",
    fill: "#6A09DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/Flame.d6638e323aff4eacf9b128895cebe9d3.svg";
export { ForwardRef as ReactComponent };